import CommunityGuidelines from 'routes/CommunityGuidelines'

export default CommunityGuidelines
